var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('v-chip',{staticClass:"chat-member",class:{ typing: _vm.typing },attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.user.friendlyName)+" "+_vm._s(_vm.typing ? "..." : null)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }